import {Component, OnInit} from '@angular/core';
import {MovieGenre} from '../../../../models/vision/movie';
import {FormsModule} from '@angular/forms';
import {ButtonDirective} from 'primeng/button';
import {InputComponent} from '../../../../components/form/input/input.component';
import {RestApiService} from '../../../../services/api/rest-api.service';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {ToastService} from '../../../../services/toast.service';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-form-genre',
  imports: [
    FormsModule,
    ButtonDirective,
    InputComponent,
    NgIf
  ],
  templateUrl: './form-genre.component.html',
  styleUrl: './form-genre.component.css'
})
export class FormGenreComponent implements OnInit {
  loading = false;
  configuration: Configuration = {} as Configuration;
  genre: MovieGenre = null!;

  constructor(
    private api: RestApiService,
    private toastService: ToastService,
    private dynamicDialogRef: DynamicDialogRef, private config: DynamicDialogConfig
  ) {
    this.configuration = config.data as Configuration;
  }

  ngOnInit() {
    this.loadData();
  }

  async loadData() {
    if (!this.configuration) {
      return;
    }
    if (this.configuration.genreId > 0) {
      try {
        this.loading = true;
        const response = await this.api.genres.byId(this.configuration.genreId);
        this.genre = response.data;
        if (!this.genre) {
          this.createNewGenre();
        }
      } finally {
        this.loading = false;
      }
    } else {
      this.createNewGenre();
    }
  }

  private createNewGenre() {
    this.genre = new MovieGenre();
    this.genre.isSubGenre = this.configuration.type === 'SubGenre';
    this.genre.name = this.configuration.name;
  }

  async save() {
    if (!this.isValid()) {
      return;
    }

    try {
      this.loading = true;
      const response = await this.api.genres.saveGenre(this.genre);
      this.genre = response.data;
      this.toastService.success('Salvataggio genere', 'Genere salvato con successo');
      this.close(this.genre);
    } catch (error) {
      this.toastService.error('Errore durante il salvataggio', 'Si è verificato un errore durante il salvataggio del genere');
    } finally {
      this.loading = false;
    }
  }

  isValid(): boolean {
    return (!!this.genre.name
      && this.genre.name.trim().length > 0
      && !!this.genre.englishName
      && this.genre.englishName.trim().length > 0);
  }

  close(result?: MovieGenre) {
    this.dynamicDialogRef.close(result);
  }

  static openDialog(dialogService: DialogService,
                    configuration: Configuration): DynamicDialogRef {
    return dialogService.open(FormGenreComponent, {
      width: '80%',
      closable: true,
      closeOnEscape: true,
      header: configuration.type === 'Genre' ? 'Genere' : 'Sotto genere',
      modal: true,
      showHeader: true,
      data: configuration
    });
  }

}

interface Configuration {
  genreId: number;
  type: 'Genre' | 'SubGenre';
  name: string;
}
